import Vue from "vue"
import Router from "vue-router"
import IndexCupo from "./views/cupos/IndexCupo.vue"
import Facturacion from "./views/utiles/Facturacion.vue"
import Resumen from "./views/utiles/Resumen.vue"
import Login from "./views/utiles/Login.vue"
import ResultadoHotelesCupo from "./views/cupos/ResultadoHotelesCupo.vue"
import PasajerosCupoAgencias from "./views/cupos/PasajerosCupoAgencias.vue"
import Espera from "./views/utiles/Espera.vue"
import Inicio from "./views/Inicio.vue"
import IndexBooking from "./views/hoteles/IndexBooking.vue"
import IndexOrlando from "./views/hoteles/IndexOrlando.vue"
import IndexUniversal from "./views/hoteles/IndexUniversal.vue"
import ResultadoHoteles from "./views/hoteles/ResultadoHoteles.vue"
import AdicionalesHoteleria from "./views/hoteles/AdicionalesHoteleria.vue"
import IndexPaquetes from "./views/paquetes/IndexPaquetes.vue"
import IndexPases from "./views/pases/IndexPases.vue"
import ResultadoPases from "./views/pases/ResultadoPases.vue"
import Volviendo from "./views/utiles/Volviendo.vue"
import IndexCruceros from "./views/cruceros/IndexCruceros.vue"
import IndexRegion from "./views/region/IndexRegion.vue"
import IndexTarifario from "./views/tarifario/IndexTarifario.vue"
import IndexIframeUtil from "./views/utiles/IndexIframeUtil.vue"
import Mensaje from "./views/utiles/Mensaje.vue"
Vue.use(Router)

export default new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      /// EN caso de no encontrar la ruta -- NOT FOUND 404
      path: "*",
      name: "notFound",
      component: Inicio,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        window.scrollTo(0, 0)
        next()
      }
    },
    {
      path: "/",
      name: "inicio",
      component: Inicio,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 20,
          name: "inicio",
          footer: true,
          navbar: true
        }
      },
      beforeEnter: (to, from, next) => {
        next()
      }
    },
    {
      path: "/cupos-hoteles", //INDEX DE CUPOS AEREOS
      name: "cuposAereos",
      component: IndexCupo,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 3,
          name: "cuposAereos",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/cupos.jpg",
          alternativo: 1, // Se toma este vaor para saber si el buscado filtra las ciudades que no tenga naeropuerto
          reservableHotel: true
        }
      },
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "cuposAereos")
        next()
      }
    },
    {
      path: "/cupos-datos-pasajeros",
      name: "pasajerosCupoAgencias",
      component: PasajerosCupoAgencias,
      meta: { requiresAuth: true, clickback: true },
      props: true,
      beforeEnter: (to, from, next) => {
        next()
      }
    },
    {
      path: "/facturacion",
      name: "facturacion",
      component: Facturacion,
      meta: { requiresAuth: true, clickback: true },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.data === undefined) {
          next(from.path)
          return
        }
        next()
      }
    },
    {
      path: "/resumen",
      name: "resumen",
      component: Resumen,
      meta: {
        clickback: false
      },
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.data === undefined) {
          next(from.path)
          return
        }
        next()
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      props: true,
      meta: {
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 10,
          name: "login",
          footer: false,
          navbar: false
        }
      },
      beforeEnter: (to, from, next) => {
        next()
      }
    },
    {
      path: "/cupos-hoteles",
      name: "hotelesCupos",
      component: ResultadoHotelesCupo,
      meta: { requiresAuth: true, clickback: true },
      props: true,
      beforeEnter: (to, from, next) => {
        if (from.name === null) {
          next({ name: "inicio" })
        }
        if (from.name != "buscandox") {
          next()
          return
        }
        if (to.params.data != null) {
          next()
          return
        }
        next({ name: "inicio" })
      }
    },
    {
      path: "/busqueda",
      name: "buscandox",
      component: Espera,
      meta: { requiresAuth: false, clickback: false },
      props: true,
      beforeEnter: (to, from, next) => {
        next()
      }
    },
    {
      path: "/e-booking",
      name: "ebooking",
      component: IndexBooking,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 12,
          name: "ebooking",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/hoteleria.jpg"
        }
      },
      props: true,
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "ebooking")
        next()
      }
    },
    {
      path: "/resultado-hoteles",
      name: "resultadoHoteles",
      component: ResultadoHoteles,
      meta: { requiresAuth: true, clickback: true },
      props: true,
      beforeEnter: (to, from, next) => {
        if (from.name === null) {
          next({ name: "inicio" })
        }
        if (from.name != "buscandox") {
          next()
          return
        }
        if (to.params.data != null) {
          next()
          return
        }
        next({ name: "inicio" })
      }
    },
    {
      path: "/orlando-ycix",
      name: "orlando",
      component: IndexOrlando,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 13,
          name: "orlando",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/tematicos.jpg"
        }
      },
      props: true,
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "orlando")
        next()
      }
    },
    {
      path: "/orlando",
      name: "orlandoDc",
      component: IndexOrlando,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 13,
          name: "orlandoDc",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/tematicos.jpg"
        }
      },
      props: true,
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "orlandoDc")
        next()
      }
    },
    {
      path: "/adicionales-hoteleria",
      name: "adicionalesHoteleria",
      component: AdicionalesHoteleria,
      meta: {
        requiresAuth: true,
        clickback: true
      },
      props: true,
      beforeEnter: (to, from, next) => {
        next()
      }
    },
    {
      path: "/paquetes",
      name: "paquetes",
      component: IndexPaquetes,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 16,
          name: "paquetes",
          footer: true,
          navbar: true
        }
      },
      props: true,
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "ebooking")
        next()
      }
    },
    {
      path: "/pases",
      name: "pases",
      component: IndexPases,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 14,
          name: "pases",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/tickets.jpg"
        }
      },
      props: true,
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "pases")
        next()
      }
    },
    {
      path: "/resultado-pases",
      name: "resultadoPases",
      component: ResultadoPases,
      meta: { requiresAuth: true, clickback: true },
      props: true,
      beforeEnter: (to, from, next) => {
        if (from.name != "buscandox") {
          next()
          return
        }
        if (to.params.data != null) {
          next()
          return
        }
        next({ name: "inicio" })
      }
    },
    {
      path: "/volviendo/:id",
      name: "volviendo",
      meta: { requiresAuth: false, clickback: false },
      component: Volviendo
    },
    {
      path: "/cruceros",
      name: "cruceros",
      component: IndexCruceros,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 15,
          name: "cruceros",
          footer: true,
          navbar: true
        }
      }
    },
    {
      path: "/paquetes/:region",
      name: "region",
      component: IndexRegion,
      props: true,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 16,
          name: "paquetes",
          footer: true,
          navbar: true
        }
      }
    },
    {
      path: "/tarifario",
      name: "tarifario",
      component: IndexTarifario,
      props: true,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 11,
          name: "tarifario",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/hoteleria2.jpg"
        }
      },
      beforeEnter: (to, from, next) => {
        window.scrollTo(0, 0)
        next()
      }
    },
    {
      path: "/respuesta-tarifario",
      name: "rsTarifario",
      component: ResultadoHoteles,
      props: true,
      meta: {
        requiresAuth: true,
        clickback: true
      }
    },
    {
      path: "/autos",
      name: "autos",
      component: IndexIframeUtil,
      props: true,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 17,
          url:
            process.env.NODE_ENV === "production" ? "https://www.allseasons.tur.ar/ws/autos" : "http://localhost/autos",
          name: "autos",
          footer: true,
          navbar: true
        }
      }
    },
    {
      path: "/asistencia",
      name: "asistencia",
      component: IndexIframeUtil,
      props: true,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 18,
          name: "asistencia",
          footer: true,
          navbar: true,
          url:
            process.env.NODE_ENV === "production"
              ? "https://www.allseasons.tur.ar/ws/asistencia-agencia"
              : "http://localhost/asistencia-agencia"
        }
      }
    },
    {
      path: "/universal-studios",
      name: "universal",
      component: IndexUniversal,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 19,
          name: "universal",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/universal-studios.jpg"
        }
      },
      props: true,
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "universal")
        next()
      }
    },
    {
      path: "/cupos-aereos", //INDEX DE CUPOS AEREOS
      name: "cuposAereosSolo",
      component: IndexCupo,
      meta: {
        requiresAuth: true,
        clickback: false,
        app: {
          // datos de inicializacion de la aplicacion
          cliente_id: 3,
          name: "cuposAereosSolo",
          footer: true,
          navbar: true,
          bkBuscador: "https://www.allseasons.tur.ar/ws/utiles/img/bg-motores/cupos.jpg",
          alternativo: 0, // Se toma este vaor para saber si el buscado filtra las ciudades que no tenga naeropuerto
          reservableHotel: false
        }
      },
      beforeEnter: (to, from, next) => {
        localStorage.setItem("inicio-as", "cuposAereosSolo")
        next()
      }
    },
    {
      /// EN caso de no encontrar la ruta -- NOT FOUND 404
      path: "/mensaje",
      name: "mensaje",
      component: Mensaje,
      meta: {
        requiresAuth: false,
        app: {
          navbar: true
        }
      },
      beforeEnter: (to, from, next) => {
        window.scrollTo(0, 0)
        next()
      }
    }
  ]
})
